<template>
    <table class="table table-striped table-condensed">
        <thead>
            <tr>
                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('month')">
                        Month <i class="fa fa-sort"></i>
                    </a>
                </th>

                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('net_change')">
                        Net Change <i class="fa fa-sort"></i>
                    </a>
                </th>

                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('new')">
                        New <i class="fa fa-sort"></i>
                    </a>
                </th>

                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('renewed')">
                        Renewed <i class="fa fa-sort"></i>
                    </a>
                </th>

                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('ending_with_renewal')">
                        Ending (with renewal)<i class="fa fa-sort"></i>
                    </a>
                </th>

                <th class="col-xs-4">
                    <a href="#" @click.prevent="sort('ending_without_renewal')">
                        Ending (without renewal)<i class="fa fa-sort"></i>
                    </a>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="row in sortedRows">
                <td>
                    {{ row.month | monthName }}
                </td>

                <td>
                    <colored-number :value="row.net_change" :format="format"></colored-number>
                </td>

                <td>
                    {{ format(row.new) }}
                </td>

                <td>
                    {{ format(row.renewed) }}
                </td>

                <td>
                    {{ format(row.ending_with_renewal) }}
                </td>

                <td>
                    {{ format(row.ending_without_renewal) }}
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr>
                <td>
                    <strong>
                        Total
                    </strong>
                </td>

                <td>
                    <strong>
                        <colored-number :value="totalSubscriptionNetChange" :format="format"></colored-number>
                    </strong>
                </td>

                <td>
                    <strong>
                        {{ format(totalNewSubscriptionCount) }}
                    </strong>
                </td>

                <td>
                    <strong>
                        {{ format(totalRenewedSubscriptionCount) }}
                    </strong>
                </td>

                <td>
                    <strong>
                        {{ format(totalEndingWithRenewalSubscriptionCount) }}
                    </strong>
                </td>

                <td>
                    <strong>
                        {{ format(totalEndingWithoutRenewalSubscriptionCount) }}
                    </strong>
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
    import moment from 'moment'
    import ColoredNumber from '@/components/Numbers/ColoredNumber'

    export default {
        components: {ColoredNumber},

        props: ['year', 'metricType', 'rows'],

        data() {
            return {
                sortBy: 'month',
                sortDirection: -1,
            }
        },

        computed: {
            sortedRows() {
                return this.rows.sort((a, b) => {
                    return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
                })
            },

            totalSubscriptionNetChange() {
                return this.rows.reduce((total, row) => {
                    return total + row.net_change
                }, 0)
            },

            totalNewSubscriptionCount() {
                return this.rows.reduce((total, row) => {
                    return total + row.new
                }, 0)
            },

            totalRenewedSubscriptionCount() {
                return this.rows.reduce((total, row) => {
                    return total + row.renewed
                }, 0)
            },

            totalEndingWithRenewalSubscriptionCount() {
                return this.rows.reduce((total, row) => {
                    return total + row.ending_with_renewal
                }, 0)
            },

            totalEndingWithoutRenewalSubscriptionCount() {
                return this.rows.reduce((total, row) => {
                    return total + row.ending_without_renewal
                }, 0)
            },

            format() {
                if (this.metricType === 'revenue') {
                    return this.$options.filters.price
                }

                return this.$options.filters.number
            }
        },

        methods: {
            sort(key) {
                if (this.sortBy === key) {
                    return this.sortDirection = -this.sortDirection
                }

                this.sortDirection = key === 'month' ? -1 : 1

                this.sortBy = key
            }
        },

        filters: {
            monthName(value) {
                return value.format('MMMM')
            }
        }
    }
</script>
